<template>
  <div class="pool" :style="{height: poolSize * 2 * slotHeight + 'px'}" :class="'size-' + poolSize">
    <div class="pool-col-outer" :style="{height: colHeight(0) + 'px', width: slotWidth + 'px'}">
      
      <div class="pool-col-start">
        <!--div class="pool-slot" v-for="fighter in fighters" :key="fighter.map" :style="{height: slotHeight + 'px'}">
          {{fighter.name}}
        </div-->
        <fighter-slot v-for="(fighter, index) in fighters" :key="index"
          :data-index="index"
          :map="fighter.map"
          :name="fighter.name"
          :country="fighter.countryIso"
          :dojo="fighter.dojoName"
          :height="slotHeight"
          :winButtonEnabled="false">
        </fighter-slot>
      </div>
      <div class="pool-col-connectors" :style="{height: poolSize * 2 * slotHeight - slotHeight + 'px'}">
        <div class="pool-col-connector" v-for="n in poolSize/2" :key="n" :style="{height:slotHeight *  3 - 1 + 'px'}"></div>
      </div>
    </div>

    <div class="pool-col-outer" v-for="n in roundCount" :key="n" :style="{height: colHeight(n) + 'px', width: slotWidth + 'px'}">
      <div class="pool-col">
        <fighter-slot :draggable="false" v-for="(fighter, index) in fightersInRound(n)" :key="index"
          :map="fighter.map"
          :name="fighter.name"
          :height="slotHeight"
          :country="fighter.countryIso"
          :backButtonEnabled="false"
          :winButtonEnabled="false">
        </fighter-slot>
      </div>
      <div class="pool-col-connectors" :style="{height: colHeight(n) + 'px'}" v-if="n < roundCount">
        <div class="pool-col-connector" v-for="o in poolSize / Math.pow(2, n) / 2" :key="o" :style="{height:slotHeight *  (Math.pow(2, n + 1) + 1) + 'px'}"></div>
      </div>
    </div>

  </div>
</template>

<style>
  .pool { display: flex; width: 100%; height: 800px; margin: 40px 0px; align-items: center; background: #fff; padding: 20px; }
  .pool-slot { width: 100%; border: 1px solid; display: flex; align-items: center; position: relative; }
  .pool-slot-ghost { opacity: 0.8; }
  .sortable-ghost { opacity: 0.8; }
  .pool-slot:last-child { margin-bottom: 0px; }
  .pool-slot-country { font-size: 0.85em; padding: 1px 4px; pointer-events: none; text-transform: uppercase; text-align: center; }
  .pool-slot-map { font-size: 0.85em; padding: 1px 4px; pointer-events: none; text-align: center; }
  .pool-slot-name { padding: 1px 4px; pointer-events: none; }
  .pool-slot-dojo { padding: 0px 4px; pointer-events: none; font-size: 0.85em; }
  .pool-slot-buttons { position: absolute; right: 0; display: flex; }

  .size-8 .pool-slot { font-size: 0.9em; }
  .size-16 .pool-slot { font-size: 0.8em; }

  .pool-col-start { width: 320px; height: 100%; display: flex; flex-direction: column; justify-content: space-between; }
  .pool-col { width: 320px; height: 100%; display: flex; flex-direction: column; justify-content: space-between; }
  .pool-col-outer { display: flex; }
  .pool-col-connectors { width: 5px; display: flex; flex-direction: column; justify-content: space-between;  }
  .pool-col-connector { width: 5px; background: #000; }

  .pool-state-title { margin: 10px 20px; font-size: 1.2em; }
  .pool-state-outer { display: flex; align-items: center; margin: 20px; }
  .pool-state { color: #ccc; }
  .pool-state.active { color: #666; }
  .pool-state-divider { background: #aaa; width: 20px; height: 1px; margin: 10px; }
  .pool-tools { display: flex; align-items: center; margin: 10px; }
  .pool-tools button { margin: 10px; }

  @media all and (max-width: 1100px) {
  .pool { width: 1100px; }    
  }
</style>

<script>

export default {
  name: 'pool',
  props: {
    poolData: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      slotHeight: 40
    }
  },
  methods: {
    colHeight: function (round) {
      switch (round) {
        case 0:
          return this.poolSize * this.slotHeight * 2 - 1 * this.slotHeight
        case 1:
          return this.poolSize * this.slotHeight * 2 - 3 * this.slotHeight
        case 2:
          return this.poolSize * this.slotHeight * 2 - 7 * this.slotHeight
        case 3:
          return this.poolSize * this.slotHeight * 2 - 15 * this.slotHeight
        case 4:
          return this.poolSize * this.slotHeight * 2 - 31 * this.slotHeight
        case 5:
          return this.poolSize * this.slotHeight * 2 - 63 * this.slotHeight
      }
    },
    fightersInRound: function (round) {
      if (round === 0) {
        return this.fighters
      }
      var roundSet = []
      var length = this.poolSize / Math.pow(2, round)
      console.log(round)
      for (var i = 0; i < length; i++) {
        var winner = false
        console.log('from: ' + (i * Math.pow(2, round)) + 'to: ' + ((i + 1) * Math.pow(2, round)))
        for (var o = i * Math.pow(2, round); o < (i + 1) * Math.pow(2, round); o++) {
          if (this.fighters[o].fightsWon >= round) {
            winner = this.fighters[o]
          }
        }
        if (winner) {
          roundSet.push(winner)
        } else {
          var dummy = {
            name: '-',
            map: 0,
            countryIso: '',
            dojoName: '',
            fightsWon: 0
          }
          roundSet.push(dummy)
        }
      }
      console.log(roundSet)
      return roundSet
    }
  },
  computed: {
    fighters: function () {
      return this.poolData
    },
    poolSize: function () {
      if (this.fighters.length > 32) return 64
      if (this.fighters.length > 16) return 32
      if (this.fighters.length > 8) return 16
      if (this.fighters.length > 4) return 8
      if (this.fighters.length > 2) return 4
      return 2
    },
    slotWidth: function () {
      if (this.poolSize > 32) return 80
      if (this.poolSize > 16) return 120
      if (this.poolSize > 8) return 210
      if (this.poolSize > 4) return 260
      return 320
    },
    roundCount: function () {
      return Math.log2(this.poolSize)
    }
  },
}
</script>
